var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonochromeCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 83",
    width: 83,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 41.5c0 15.662-8.676 29.298-21.485 36.363a21.983 21.983 0 002.034-1.347c0-1.297.432-49.856.432-49.856a3.32 3.32 0 00-3.316-3.316H24.07a3.32 3.32 0 00-3.316 3.316l-.002 50.79C8.347 70.273 0 56.861 0 41.5 0 18.58 18.58 0 41.5 0S83 18.58 83 41.5zM34.764 82.456v.026c-6.23-.779-14.012-4.67-14.012-4.67v-.363a41.224 41.224 0 0014.012 5.007zm19.409-1.427c-2.001.629-3.395.91-3.395.91V71.643h3.979a1.258 1.258 0 100-2.516H30.785a1.258 1.258 0 100 2.516h3.98v10.814a42.05 42.05 0 0010.488.377 25.15 25.15 0 001.96-.223 41.352 41.352 0 006.96-1.58zm0 0c2.084-.654 4.828-1.685 7.342-3.166a41.261 41.261 0 01-7.342 3.166zm-6.96 1.58c-.648.09-1.302.165-1.96.224-2.678.208-5.864.137-7.973-.047V71.642h10.983s-.198 8.845 0 10.762c-.32.078-.673.146-1.05.206zm11.083-51.99h-32.02a1.258 1.258 0 110-2.516h32.02a1.258 1.258 0 110 2.516zm-32.02 9.727h32.02a1.258 1.258 0 100-2.516h-32.02a1.258 1.258 0 100 2.516zm32.02 9.726h-32.02a1.258 1.258 0 110-2.516h32.02a1.258 1.258 0 110 2.516z",
    fill: "var(--color-secondary-light)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonochromeCompany);
export default __webpack_public_path__ + "static/media/monochrome-company.74c994b24ed3d662862b835a825b8448.svg";
export { ForwardRef as ReactComponent };